"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getInitialState = void 0;
var actions_1 = require("../../utils/actions");
var actions_2 = require("./actions");
var getInitialState = function (id) { return ({
    id: id,
    firstName: '',
    lastName: '',
    address1: '',
    address2: '',
    address3: '',
    city: '',
    state: '',
    zip: '',
    country: 'US',
    trackFrom: null,
    isComplete: false,
}); };
exports.getInitialState = getInitialState;
var setAddress = function (_a) {
    var state = _a.state, action = _a.action, isTrackingThis = _a.isTrackingThis;
    if (!isTrackingThis) {
        return state;
    }
    var address = action.payload.address;
    return __assign(__assign({}, state), address);
};
var setAddressField = function (_a) {
    var _b;
    var state = _a.state, action = _a.action, isTrackingThis = _a.isTrackingThis;
    if (!isTrackingThis) {
        return state;
    }
    var _c = action.payload, fieldName = _c.fieldName, value = _c.value;
    return __assign(__assign({}, state), (_b = {}, _b[fieldName] = value, _b));
};
var trackAddress = function (_a) {
    var state = _a.state, action = _a.action, isThisId = _a.isThisId;
    var _b = action.payload, trackId = _b.trackId, address = _b.address;
    if (!isThisId || !trackId) {
        return state;
    }
    return __assign(__assign(__assign({}, state), address), { id: state.id, trackFrom: trackId });
};
var untrackAddress = function (_a) {
    var state = _a.state, isThisId = _a.isThisId;
    if (!isThisId) {
        return state;
    }
    return __assign(__assign({}, state), { trackFrom: null });
};
var setAddressIsComplete = function (_a) {
    var state = _a.state, action = _a.action, isThisId = _a.isThisId;
    if (!isThisId) {
        return state;
    }
    var isComplete = action.payload.isComplete;
    return __assign(__assign({}, state), { isComplete: isComplete });
};
var getAddressReducer = function (id, stateFromStore, action) {
    var initialState = (0, exports.getInitialState)(id);
    var state = stateFromStore || initialState;
    var reducer = function () {
        var addressId = (action.payload || {}).addressId;
        var isThisId = state.id === id && addressId === id;
        var isTrackingThis = state.trackFrom
            ? state.id === id && addressId === state.trackFrom
            : isThisId;
        if ((0, actions_1.isType)(action, actions_2.setAddressAction)) {
            return setAddress({
                state: state,
                action: action,
                initialState: initialState,
                isThisId: isThisId,
                isTrackingThis: isTrackingThis,
            });
        }
        else if ((0, actions_1.isType)(action, actions_2.setAddressFieldAction)) {
            return setAddressField({
                state: state,
                action: action,
                initialState: initialState,
                isThisId: isThisId,
                isTrackingThis: isTrackingThis,
            });
        }
        else if ((0, actions_1.isType)(action, actions_2.trackAddressAction)) {
            return trackAddress({
                state: state,
                action: action,
                initialState: initialState,
                isThisId: isThisId,
                isTrackingThis: isTrackingThis,
            });
        }
        else if ((0, actions_1.isType)(action, actions_2.untrackAddressAction)) {
            return untrackAddress({
                state: state,
                action: action,
                initialState: initialState,
                isThisId: isThisId,
                isTrackingThis: isTrackingThis,
            });
        }
        else if ((0, actions_1.isType)(action, actions_2.setAddressIsCompleteAction)) {
            return setAddressIsComplete({
                state: state,
                action: action,
                initialState: initialState,
                isThisId: isThisId,
                isTrackingThis: isTrackingThis,
            });
        }
        else {
            return state;
        }
    };
    return reducer();
};
exports.default = getAddressReducer;
